var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature_facilities"},[_c('ul',{staticClass:"facilities_list list list_floor"},_vm._l((_vm.lists),function(list){return _c('li',{domProps:{"innerHTML":_vm._s(list)}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }